import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Feed from "@/pages/Feed";
import Recipes from "@/pages/Recipes";
import RecipeDetail from "@/pages/RecipeDetail";
import Ratings from "@/pages/Ratings";
import ProductDetail from "@/pages/ProductDetail";
import BuildBar from "@/pages/BuildBar";
import Registry from "@/pages/Registry";
import RegistryDetail from "@/pages/RegistryDetail";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import Planner from "@/pages/Planner";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex h-screen items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/feed" element={<Protected><Feed /></Protected>} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/recipes/:id" element={<RecipeDetail />} />
        <Route path="/ratings" element={<Ratings />} />
        <Route path="/ratings/:id" element={<ProductDetail />} />
        <Route path="/build-bar" element={<BuildBar />} />
        <Route path="/registry" element={<Registry />} />
        <Route path="/registry/:id" element={<RegistryDetail />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/groups/:id" element={<GroupDetail />} />
        <Route path="/planner" element={<Planner />} />
        <Route path="/profile" element={<Protected><Profile /></Protected>} />
        <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<Shell />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
